import { forbiddenAuthoredPresentationFields } from './hand-contract.js';
import type { FigureSpec } from './model.js';

export interface AuthoringAudit {
  valid: boolean;
  violations: string[];
}

const forbidden = new Set<string>(forbiddenAuthoredPresentationFields);

export function auditAuthoringSpec(spec: FigureSpec): AuthoringAudit {
  const violations: string[] = [];
  visit(spec, '', violations);
  return { valid: violations.length === 0, violations };
}

export function assertAuthoringBoundary(spec: FigureSpec): void {
  const audit = auditAuthoringSpec(spec);
  if (!audit.valid) throw new Error(`authoring boundary: presentation fields are forbidden (${audit.violations.join(', ')})`);
}

function visit(value: unknown, path: string, violations: string[]): void {
  if (!value || typeof value !== 'object') return;
  if (Array.isArray(value)) {
    value.forEach((item, index) => visit(item, `${path}[${index}]`, violations));
    return;
  }
  Object.entries(value).forEach(([key, child]) => {
    const next = path ? `${path}.${key}` : key;
    const isHostViewport = next === 'viewport.width' || next === 'viewport.height';
    if (forbidden.has(key) && !isHostViewport) violations.push(next);
    visit(child, next, violations);
  });
}
